import { z } from '@hono/zod-openapi';

export const shopNewsRecipientType = z.enum(['ALL_USERS', 'SINGLE_USERS', 'GROUPS']);
export type ShopNewsRecipientType = z.infer<typeof shopNewsRecipientType>;

export const shopNewsRecipientSchema = z.object({
  type: shopNewsRecipientType,
  recipients: z.object({ id: z.string().uuid(), label: z.string() }).array()
});

export type ShopNewsRecipient = z.infer<typeof shopNewsRecipientSchema>;
